export default "./dist/stdassets/images/icons/globe-share.png";